import axios from "axios";
import { LMS_TOKEN } from "../../../../utils/cookiesmanager";
import { LMS_BASE_URL } from "../../../../utils/http/http-common";

export const getPostAssessmentQuestionApiCall = async (args) => {
    const {courseId  = 1 , languageId = 1} = args;

    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/course-postassessment-questions?courseId=${courseId }&languageId=${languageId}`,{
        headers:{
            Authorization:`Bearer ${authToken}`
        }
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};

export const savePostCourseAssessment = async (payload) => {
    const authToken = localStorage.getItem(LMS_TOKEN);

    try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/post-assessment`, payload ,{
        headers:{
            Authorization:`Bearer ${authToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};